import { Deserializable } from '../deserializable';

export class Media implements Deserializable {
    public id: number;
    public entityId: number;
    public entityType: string;
    public name: string;
    public fileName: string;
    public fileType: string;
    public tag: string;
    public mimeType: string;
    public version: number;
    public createdBy: number;
    public createdDate: Date;
    public updatedDate: Date;

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
      }
}
